export default [
    {
        path: "add-paypal-payment-setting",
        name: "addpaypalpaymentsetting",
        component: () =>
            import(
                /* webpackChunkName: "AddSingleSubscriber" */ "../pages/paypalPayment/AddPaypalPaymentSetting.vue"
            ),
        meta: {
            title: `Add Paypal Payment Setting`,
        },
    }
];
